import { CModal, CModalBody } from '@coreui/react'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ProfileForm from 'src/components/ProfileForm/ProfileForm'
import useProfileSubmit from 'src/hooks/forms/profile/useProfileSubmit'
import styles from './profileModal.module.scss'

const getAccountName = (contactList, viewAccount) => {
  if (!contactList?.length || !viewAccount) return ''
  const { SecondaryContact } = viewAccount
  const contact = contactList.find((contact) => contact.id === SecondaryContact)
  if (!contact) return ''
  return `${contact.firstname} ${contact.lastname}`
}

/**
 * @param {Object} props
 * @param {Object} props.viewAccount
 * @param {Array} props.contactList
 * @param {boolean} props.openProfile
 * @param {(open: boolean) => void} props.setOpenProfile
 * @param {(alert: Object) => void} props.setAlertComponent
 * @param {() => void} props.onPasswordResetClick
 */
const ProfileModal = ({
  viewAccount,
  contactList,
  openProfile,
  setOpenProfile,
  setAlertComponent,
  onPasswordResetClick,
}) => {
  const { t } = useTranslation('common')

  const handleClose = () => {
    setOpenProfile(false)
  }

  const { defaultValues, handleSubmit, isLoading } = useProfileSubmit({
    viewAccount,
    contactList,
    onSuccess: handleClose,
    setAlertComponent,
  })

  const accountName = getAccountName(contactList, viewAccount)

  return (
    <CModal alignment="center" visible={openProfile} size="lg" onClose={handleClose}>
      <CModalBody className={styles.modalStyle}>
        <div className={styles.headerContainerDiv}>
          <div className={styles.headerTitleDiv}>
            <div>{accountName}</div>
            <IconButton title="Close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.headerNameDiv}>{t('profile.details.updateInformation')}</div>
        </div>
        <div className={styles.contentContainerDiv}>
          <ProfileForm
            defaultValues={defaultValues}
            onPasswordResetClick={onPasswordResetClick}
            onSubmit={handleSubmit}
            onCancel={handleClose}
            isLoading={isLoading}
            hideTitles
          />
        </div>
      </CModalBody>
    </CModal>
  )
}

ProfileModal.defaultProps = {
  viewAccount: {},
  contactList: [],
  openProfile: false,
  setOpenProfile: noop,
  onPasswordResetClick: noop,
  setAlertComponent: noop,
}

ProfileModal.propTypes = {
  viewAccount: PropTypes.object,
  contactList: PropTypes.array,
  openProfile: PropTypes.bool,
  setOpenProfile: PropTypes.func,
  onPasswordResetClick: PropTypes.func,
  setAlertComponent: PropTypes.func,
}

export default ProfileModal
